import { render, staticRenderFns } from "./survey.vue?vue&type=template&id=76005b05&scoped=true"
import script from "./survey.vue?vue&type=script&lang=js"
export * from "./survey.vue?vue&type=script&lang=js"
import style0 from "./survey.vue?vue&type=style&index=0&id=76005b05&prod&scoped=true&lang=css"
import style1 from "./survey.vue?vue&type=style&index=1&id=76005b05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76005b05",
  null
  
)

export default component.exports